import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseSummaryStudyCategoryProgressBranches } from '@/api/responses/manage/summaryStudyCategoryProgressBranches'

export namespace SummaryStudyCategoryProgressBranchesApi {
  /**
   * 教室別通常学習進捗平均一覧取得API
   *
   * @param academyId 塾ID
   * @param studyCategoryId 教材ID
   * @returns 教室別平均一覧
   */
  export async function getSummary(
    academyId: number,
    studyCategoryId: number
  ): Promise<ApiResponseSummaryStudyCategoryProgressBranches> {
    const params = {
      studyCategoryId: studyCategoryId,
    }
    return await ApiBase.get(`/manage/summaryProgress/academies/${academyId}/branches`, params)
  }
}
